import { anatomyToVector } from "./index6.js";
import { RgDefaultCreate } from "./index15.js";
import { getRequiredCores } from "./index17.js";
import { getInnerMuscles } from "./index19.js";
import { hasBoneAt } from "./index20.js";
import { BoneSide, RG_TYPE } from "@project-rouge/rg-core";
import { CopyAcrossFloors, MuscleToVector, RgShallowClone, SignedAngle, Vectors } from "@project-rouge/rg-three";
import { MathUtils, Vector3 } from "three";
var _boneAVector = new Vector3();
var _boneBVector = new Vector3();
var _center = new Vector3();
var _muscleVector = new Vector3();
function addCornerCores(joint, dataset) {
	const { corridorWidth, cornerCore, f2fHeight } = dataset.aggConfig;
	const boneA = getFacingBone(joint);
	const boneB = joint.bones.find((b) => b !== boneA);
	const muscles = getInnerMuscles(boneA, boneB);
	anatomyToVector(boneA, _boneAVector);
	anatomyToVector(boneB, _boneBVector);
	const rot = [
		0,
		SignedAngle(Vectors.Right, _boneAVector) * MathUtils.RAD2DEG,
		0
	];
	const size = [
		cornerCore.size[0],
		f2fHeight,
		cornerCore.size[1]
	];
	const diff = [0, 0];
	for (let i = 0; i < muscles.length; i++) {
		const m = muscles[i];
		let pointIndex = m.bone.joints[0] === joint ? 0 : 1;
		pointIndex = m.side === BoneSide.Right ? pointIndex : (pointIndex + 1) % 2;
		if (m.lockEnds[pointIndex]) continue;
		MuscleToVector(m, _muscleVector);
		diff[i] = _muscleVector.length() - m.realLength;
	}
	size[0] += diff[0];
	size[2] += diff[1];
	if (boneA.joints[0] !== joint) _boneAVector.negate();
	if (boneB.joints[0] !== joint) _boneBVector.negate();
	_boneAVector.normalize();
	_boneBVector.normalize();
	_center.setScalar(0).addScaledVector(_boneAVector, corridorWidth + cornerCore.size[0] - diff[0]).addScaledVector(_boneBVector, corridorWidth + cornerCore.size[1] - diff[1]).multiplyScalar(.5);
	const pos = new Vector3().fromArray(joint.pos).addScaledVector(_boneAVector, diff[0]).addScaledVector(_boneBVector, diff[1]).add(_center);
	const { requiredFireLifts } = getRequiredCores(joint, dataset);
	return CopyAcrossFloors({
		list: [RgDefaultCreate({
			pos: pos.toArray(),
			size,
			type: RG_TYPE.Core,
			anchor: [
				.5,
				0,
				.5
			],
			rot,
			data: {
				jointID: joint.id,
				muscleID: "",
				hasFireLift: !!requiredFireLifts,
				hasNonFireLift: !requiredFireLifts,
				level: -1,
				levelId: "",
				isCorner: true
			}
		})].map(RgShallowClone),
		floors: Math.max(boneA.floors, boneB.floors),
		height: f2fHeight,
		yStart: 0
	});
}
function getFacingBone(joint) {
	const [boneA, boneB] = joint.bones;
	const startFromJoint = boneA.joints[0] === joint;
	if (hasBoneAt({
		bone: boneA,
		right: startFromJoint,
		start: startFromJoint
	})) return boneA;
	return boneB;
}
export { addCornerCores };

//# sourceMappingURL=index21.js.map